import { prompt, type PromptDefinition } from './models';

export const PROJECT_MANAGER_PROMPTS = [
    prompt(
        'Plan change',
        'Which milestones and deliverables are documented for work on this building?',
        'Which buildings have project milestones or deliverables approaching their due dates?'
    ),
    prompt(
        'Plan change',
        'What project actions remain open for this building?',
        'Which buildings have overdue or unowned project actions in the records?'
    ),
    prompt(
        'Plan change',
        'What dependencies are blocking recorded project work on this building?',
        'Compare documented project blockers across my buildings.'
    ),
    prompt(
        'Plan change',
        'Find project meeting records for this building concerning…',
        'Find project meeting records across my buildings concerning…',
        'prefill'
    ),
    prompt(
        'Plan change',
        "Which variations or scope changes are documented for this building's project?",
        'Which buildings have project scope changes awaiting documented decisions?'
    ),
    prompt(
        'Plan change',
        "What evidence supports progress reported for this building's project?",
        'Which buildings have project progress claims without supporting evidence?'
    ),
    prompt(
        'Plan change',
        "Which approvals are still needed for this building's project deliverables?",
        'Which buildings have project deliverables awaiting documented approval?'
    ),
    prompt(
        'Plan change',
        'Find project variations for this building relating to…',
        'Find project variations across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Plan change',
        "What risks and mitigations are listed in this building's project records?",
        'Which buildings have project risks without a documented mitigation owner?'
    ),
    prompt(
        'Plan change',
        "Which defects or incomplete works prevent handover of this building's project?",
        'Which buildings have project handover blocked by defects or incomplete works?'
    ),
    prompt(
        'Plan change',
        "What documents are missing from this building's project closeout package?",
        'Compare project closeout evidence gaps across my buildings.'
    ),
    prompt(
        'Plan change',
        'Prepare a project status draft for this building focused on…',
        'Prepare a project status comparison across my buildings focused on…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
